<template>
  <div>
    <Dashboard type="home" class="px-4" style="margin-bottom: 14px" />
    <div class="m-dashboard-menu px-4 mb-4">
      <div v-if="isSubMenu" class="back-button" @click="goBackToMainMenu">
        <div class="flex items-center justify-center">
          <feather-icon icon="ArrowLeftIcon" class="mr-2" />
          <span>뒤로가기</span>
        </div>
      </div>

      <div v-for="menu in displayMenus" :key="menu.name" class="item" style="background: #fff" @click="onMenuClick(menu)" v-if="enableCard(menu)">
        <div>
          <div class="mt-4 mb-2 flex justify-center">
            <feather-icon :icon="menu.icon" />
          </div>
          <div class="text-center">
            <span style="font-size: 1.125rem; font-weight: 500; color: #353535">{{ menu.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <vs-card class="m-alarm-list mx-4">
      <div>
        <h5>
          <i class="dot"></i>알림현황 <span>(최근 {{ alertList.length }}건)</span>
        </h5>
      </div>
      <div v-for="alert in alertList" :key="alert.id" class="mt-3 p-3 board" @click="onClickAlert(alert)">
        <p style="font-size: 13px; color: #000; font-weight: 400">{{ alert.message }}</p>
        <p class="mt-2" style="font-size: 12px; color: #696d71; font-weight: 400">{{ alert.created_at }}</p>
      </div>
      <div v-if="alertList.length === 0" class="mt-3 p-6 board">
        <p style="font-size: 13px; color: #000; font-weight: 400">미확인 알림이 없습니다</p>
      </div>
    </vs-card>
  </div>
</template>

<script>
import DonutChartCard from "@/components/DonutChartCard";
import HomeNotificationCard from "@/components/HomeNotificationCard";
import CommunityHealthinfoCard from "@/components/CommunityHealthinfoCard";
import CommunityWorkNewsCard from "@/components/CommunityWorkNewsCard";
import CommunityBusinessNewsCard from "@/components/CommunityBusinessNewsCard";
import HealthSafetyBudgetExecutionRateChart from "@/views/graph/HeathSafetyBudgetExecutionRateChart";
import Dashboard from "./Dashboard.vue";

export default {
  components: {
    HealthSafetyBudgetExecutionRateChart,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard,
    Dashboard,
  },
  data() {
    return {
      rootPath: "",
      successLoadGraph: false,
      alertList: [],
      isSubMenu: false,
      currentMenus: [],
      parentMenuName: "",
    };
  },
  async created() {
    const paths = this.$route.path.split("/");
    this.rootPath = `/${paths[1]}/${paths[2]}`;
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then(() => {
      this.successLoadGraph = true;
    });
  },
  computed: {
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    mobileCardMenus() {
      if (Number(`${this.projectId}`) === 2) {
        return [
          {
            url: `dashboard`,
            name: "스마트 대시보드",
            icon: "PieChartIcon",
            boardId: "",
            onlyAdmin: true,
          },
          {
            name: "안전·보건 점검",
            icon: "BookOpenIcon",
            children: [
              {
                url: 'tab/137/write',
                name: '안전·보건 점검 계획',
                icon: "FileTextIcon",
                boardId: "137",
              },
              {
                url: 'tab/100/write',
                name: '작업장 합동점검',
                icon: "UsersIcon",
                boardId: "100",
              },
              {
                url: 'tab/289/write',
                name: '안전보건 순회점검표(사무실)',
                icon: "CheckSquareIcon",
                boardId: "289",
              },
              {
                url: 'tab/291/write',
                name: '안전 순회점검표(현장)',
                icon: "CheckSquareIcon",
                boardId: "291",
              },
              {
                url: 'tab/290/write',
                name: '보건 순회점검표(순회)',
                icon: "CheckSquareIcon",
                boardId: "290",
              },
              {
                url: 'tab/435/write',
                name: '안전·보건 점검 결과',
                icon: "UserCheckIcon",
                boardId: "435",
              },
              {
                url: 'tab/377/write',
                name: 'TBM(작업 전 안전점검회의)',
                icon: "UsersIcon",
                boardId: "377",
              },
              {
                url: 'tab/438/write',
                name: '휴게시설 주요 체크리스트',
                icon: "AlertTriangleIcon",
                boardId: "438",
              },
              {
                url: 'tab/163/write',
                name: '일일안전보건점검일지',
                icon: "AlertTriangleIcon",
                boardId: "163",
              },
              {
                url: 'tab/296/write',
                name: '동청사 안전점검표',
                icon: "AlertTriangleIcon",
                boardId: "296",
              },
              {
                url: 'tab/168/write',
                name: '시설물 관리(공통)',
                icon: "AlertTriangleIcon",
                boardId: "168",
              },
              {
                url: 'tab/198/write',
                name: '계절성 업무에 따른 관리대책',
                icon: "AlertTriangleIcon",
                boardId: "198",
              },
              {
                url: 'tab/1020/write',
                name: '안전검사 기계기구 리스트',
                icon: "AlertTriangleIcon",
                boardId: "1020",
              }
            ]
          },
          {
            url: "tab/161/write",
            name: "정기 위험성평가",
            icon: "AlertTriangleIcon",
            boardId: "161",
          },
          {
            url: "tab/117/write",
            name: "산업재해조사표",
            icon: "AlertTriangleIcon",
            boardId: "117",
          },
        ];
      } else if (Number(`${this.projectId}`) === 5) {
        return [
          {
            url: `dashboard`,
            name: "스마트 대시보드",
            icon: "PieChartIcon",
            boardId: "",
            onlyAdmin: true,
          },
          {
            url: "tab/613/write",
            name: "유해·위험요인 점검 체크리스트",
            icon: "CheckSquareIcon",
            boardId: "613",
          },
          {
            url: "tab/649/write",
            name: "(건축물)유해·위험요인 발생 및 조치현황",
            icon: "ToolIcon",
            boardId: "649",
          },
          {
            url: "tab/640/write",
            name: "중대시민재해 발생 보고서",
            icon: "FileTextIcon",
            boardId: "640",
          },
        ];
      }
      return [];
    },
    displayMenus() {
      if (this.isSubMenu) {
        return this.currentMenus;
      }
      return this.mobileCardMenus;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    boardIds() {
      return this.$store.state.menu.availableBoardIds;
    },
    myLv() {
      return parseInt(`${this.$store.state.auth.userInfo.position}`);
    },
    companyInfo() {
      return this.$store.state.auth.companyInfo;
    },
    hasDashboardCharts() {
      const memberInfo = this.$store.state.member.memberInfo;
      const hasDashboardCharts = memberInfo.has_dashboard_charts;
      if (hasDashboardCharts) {
        const list = [];
        for (const chart of hasDashboardCharts) {
          if (chart.visible && Number(`${chart.project_id}`) === Number(`${this.projectId}`)) {
            const code = chart.dashboard_chart.code;
            list.push(code);
          }
        }
        return list;
      }

      return undefined;
    },
    rootCompanyList() {
      const list = [];
      for (const company of this.$store.state.company.companyList) {
        if (typeof company !== "undefined" && typeof company.com_type !== "undefined" && company.com_type === "head") {
          list.push(company);
        }
      }
      return list;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      for (const company of this.rootCompanyList) {
        if (myInfo.company_id === company.id) {
          isAdmin = true;
          break;
        }
      }
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    comGroupList() {
      const companyTree = this.$store.state.company.companyTree;
      let maxDepth = 0;
      const list = [];
      let hasRootHead = false;
      const headList = [];

      if (companyTree && companyTree.length > 0) {
        for (const com of companyTree) {
          if (!com || !com.descendant) {
            continue;
          }

          if (typeof com.descendant !== "undefined" && typeof com.descendant.com_type !== "undefined" && com.descendant.com_type === "head") {
            hasRootHead = true;
            headList.push(com.descendant.com_name);
          }
          if (com.depth > maxDepth) {
            maxDepth = com.depth;
          }

          const parentId = com.descendant.parent_id ? com.descendant.parent_id : com.descendant.id;
          if (list[`com_${parentId}`]) {
            list[`com_${parentId}`][com.descendant.id] = com.descendant.com_name;
          } else {
            list[`com_${parentId}`] = { [com.descendant.id]: com.descendant.com_name };
          }
        }
      }

      return {
        maxDepth,
        hasRootHead,
        headList,
        list,
      };
    },
    dataType() {
      if (Number(`${this.comGroupList.maxDepth}`) === 0) {
        return "detail";
      }
      return "company";
    },
  },
  async mounted() {
    await this.loadCompanyList();

    if (this.verticalNavMenuWidth !== "default") {
      await this.loadAlertList();
    }
  },
  methods: {
    async loadCompanyList() {
      const page = 1;
      const perPage = 10000;
      const projectId = this.projectId;
      await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId });
      await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
        page,
        perPage,
        comType: "head",
        projectId,
      });
    },

    async loadAlertList() {
      const options = {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,

        page_read: 1,
        per_page_read: 5,
        days_before_read: 30,
      };
      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch("approval/LOAD_NOTIFICATION_LIST", options);

      const unreadList = this.$store.state.approval.alertUnReadList;

      this.alertList = unreadList;
    },

    onClickAlert(alert) {
      const data = JSON.parse(alert.data);
      if (data && data.project_id && data.board_id && data.post_id) {
        const projectId = data.project_id;
        const boardId = data.board_id;
        const postId = data.post_id;
        this.$router.push({ path: `/project/${projectId}/tab/${boardId}/write/${postId}` });
      }
    },

    onMenuClick(menu) {
      // children이 있는 경우 서브메뉴로 이동
      if (menu.children && menu.children.length > 0) {
        this.isSubMenu = true;
        this.currentMenus = menu.children;
        this.parentMenuName = menu.name;
      } else if (menu.url) {
        // children이 없는 경우 기존대로 라우터 이동
        this.$router.push({ path: `${this.rootPath}/${menu.url}` });
      }
    },

    goBackToMainMenu() {
      this.isSubMenu = false;
      this.currentMenus = [];
      this.parentMenuName = "";
    },

    enableCard(menu) {
      // 대시보드는 관리자만 접근 가능
      if (menu.onlyAdmin && !this.isAdmin) {
        return false;
      }

      if (!menu.boardId) return true;

      // boardIds가 정의되지 않았거나 배열이 아닌 경우 기본적으로 접근 허용
      if (!this.boardIds || !Array.isArray(this.boardIds)) {
        return true;
      }

      // 권한을 갖고 있는 게시판 번호들 중에 해당 게시판이 있는지 확인
      return this.boardIds.includes(Number(`${menu.boardId}`));
    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.m-dashboard-menu {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  .back-button {
    grid-column: 1 / -1;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 1rem;
    transition: background-color 0.2s;

    &:hover {
      background: #e9ecef;
    }

    span {
      font-size: 1rem;
      font-weight: 500;
      color: #495057;
    }
  }
  .item {
    padding: 0.5rem;
    min-height: 100px;
    margin-bottom: 0rem;
    box-shadow: 0px 2px 8px 0px #00000021;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.2s;

    &:hover {
      transform: translateY(-2px);
    }
  }
  @media (min-width: 960px) {
    .item {
      padding: 2.5rem 0.5rem;
    }
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
.m-alarm-list {
  width: auto;
  .board {
    border: 1px solid #cdcdcd;
  }
}
</style>
